// NOTE: Do not add any external dependency here! This util is used inside independent "bettingLoader".
import type { Config } from './LocaleManager';

export const LOCALES: Config[] = [
    {
        dataFeed: ['en', 'en_US'],
        cms: ['en'],
        banner: 'en',
        reactIntl: 'en',
        messages: 'en',
        dateFns: 'en-US',
        i18nCountries: 'en',
        transifex: 'l:en',
        matchTracker: 'en',
        polyfill: 'en',
    },
    {
        dataFeed: ['ru', 'ru_RU', 'ru_RF'],
        cms: ['ru'],
        banner: 'ru',
        reactIntl: 'ru',
        messages: 'ru',
        dateFns: 'ru',
        i18nCountries: 'ru',
        transifex: 'l:ru',
        matchTracker: 'ru',
        polyfill: 'ru',
    },
    {
        dataFeed: ['ru_RF', 'ru', 'ru_RU'],
        cms: ['ru_RF'],
        banner: 'ru',
        reactIntl: 'ru',
        messages: 'ru_RF',
        dateFns: 'ru',
        i18nCountries: 'ru',
        transifex: 'l:ru_RU',
        matchTracker: 'ru',
        polyfill: 'ru',
    },
    {
        dataFeed: ['sv', 'sv_SE'],
        cms: ['sv'],
        banner: 'se',
        reactIntl: 'sv',
        messages: 'sv',
        dateFns: 'sv',
        i18nCountries: 'sv',
        transifex: 'l:sv',
        matchTracker: 'en',
        polyfill: 'sv',
    },
    {
        dataFeed: ['zh_CN', 'zh'],
        cms: ['zh', 'cn', 'zh_CN'],
        banner: 'cn',
        reactIntl: 'zh',
        messages: 'zh',
        dateFns: 'zh-CN',
        i18nCountries: 'zh',
        transifex: 'l:zh_CN',
        matchTracker: 'zh',
        polyfill: 'zh',
    },
    {
        dataFeed: ['pt_BR', 'pt', 'pt_PT'],
        cms: ['pt'],
        banner: 'pt',
        reactIntl: 'pt',
        messages: 'pt',
        dateFns: 'pt',
        i18nCountries: 'pt',
        transifex: 'l:pt_BR',
        matchTracker: 'pt',
        polyfill: 'pt',
    },
    {
        dataFeed: ['uk', 'uk_UA'],
        cms: ['uk', 'ua', 'uk-ua', 'uk_UA'],
        banner: 'uk-ua',
        reactIntl: 'uk',
        messages: 'uk',
        dateFns: 'uk',
        i18nCountries: 'uk',
        transifex: 'l:uk',
        matchTracker: 'ukr',
        polyfill: 'uk',
    },
    {
        dataFeed: ['ja', 'ja_JP'],
        cms: ['ja'],
        banner: 'ja',
        reactIntl: 'ja',
        messages: 'ja',
        dateFns: 'ja',
        i18nCountries: 'ja',
        transifex: 'l:ja',
        matchTracker: 'ja',
        polyfill: 'ja',
    },
    {
        dataFeed: ['de', 'de_DE'],
        cms: ['de'],
        banner: 'de',
        reactIntl: 'de',
        messages: 'de',
        dateFns: 'de',
        i18nCountries: 'de',
        transifex: 'l:de',
        matchTracker: 'de',
        polyfill: 'de',
    },
    {
        dataFeed: ['pl', 'pl_PL'],
        cms: ['pl'],
        banner: 'pl',
        reactIntl: 'pl',
        messages: 'pl',
        dateFns: 'pl',
        i18nCountries: 'pl',
        transifex: 'l:pl',
        matchTracker: 'pl',
        polyfill: 'pl',
    },
    {
        dataFeed: ['pt', 'pt_PT', 'pt_BR'],
        cms: ['pt_PT'],
        banner: 'pt',
        reactIntl: 'pt',
        messages: 'pt_PT',
        dateFns: 'pt',
        i18nCountries: 'pt',
        transifex: 'l:pt',
        matchTracker: 'pt',
        polyfill: 'pt',
    },
    {
        dataFeed: ['en_CA', 'en', 'en_US'],
        cms: ['en_CA'],
        banner: 'en-ca',
        reactIntl: 'en-CA',
        messages: 'en_CA',
        dateFns: 'en-CA',
        i18nCountries: 'en',
        transifex: 'l:en_CA',
        matchTracker: 'en',
        polyfill: 'en',
    },
    {
        dataFeed: ['fr_CA', 'fr'],
        cms: ['fr_CA'],
        banner: 'fr-ca',
        reactIntl: 'fr-CA',
        messages: 'fr_CA',
        dateFns: 'fr-CA',
        i18nCountries: 'fr',
        transifex: 'l:fr_CA',
        matchTracker: 'fr',
        polyfill: 'fr',
    },
    {
        dataFeed: ['ro', 'ro_RO'],
        cms: ['ro'],
        banner: 'ro',
        reactIntl: 'ro',
        messages: 'ro',
        dateFns: 'ro',
        i18nCountries: 'ro',
        transifex: 'l:ro',
        matchTracker: 'ro',
        polyfill: 'ro',
    },
    {
        dataFeed: ['hu', 'hu_HU'],
        cms: ['hu'],
        banner: 'hu',
        reactIntl: 'hu',
        messages: 'hu',
        dateFns: 'hu',
        i18nCountries: 'hu',
        transifex: 'l:hu',
        matchTracker: 'hu',
        polyfill: 'hu',
    },
    {
        dataFeed: ['es', 'es_ES'],
        cms: ['es'],
        banner: 'es',
        reactIntl: 'es',
        messages: 'es',
        dateFns: 'es',
        i18nCountries: 'es',
        transifex: 'l:es',
        matchTracker: 'es',
        polyfill: 'es',
    },
    {
        dataFeed: ['th'],
        cms: ['th'],
        banner: 'th',
        reactIntl: 'th',
        messages: 'th',
        dateFns: 'th',
        i18nCountries: 'th',
        transifex: 'l:th_TH',
        matchTracker: 'th',
        polyfill: 'th',
    },
    {
        dataFeed: ['tl'],
        cms: ['tl_PH'],
        banner: 'tl-ph',
        reactIntl: 'fil',
        messages: 'fil',
        dateFns: 'en-US',
        i18nCountries: 'en',
        transifex: 'l:fil_PH',
        matchTracker: 'en',
        polyfill: 'fil',
    },
    {
        dataFeed: ['vi'],
        cms: ['vi'],
        banner: 'vi',
        reactIntl: 'vi',
        messages: 'vi',
        dateFns: 'vi',
        i18nCountries: 'vi',
        transifex: 'l:vi_VN',
        matchTracker: 'vi',
        polyfill: 'vi',
    },
    {
        dataFeed: ['hi'],
        cms: ['hi'],
        banner: 'hi',
        reactIntl: 'hi',
        messages: 'hi',
        dateFns: 'hi',
        i18nCountries: 'hi',
        transifex: 'l:hi_IN',
        matchTracker: 'en',
        polyfill: 'hi',
    },
];

export const DEFAULT_LOCALE: Config = LOCALES[0]!;
